import { ProdOrder } from '../prod-order'

export class ProdOrderCommand {
  public force: boolean

  constructor(
    public prodOrderId: string,
    public type: ProdOrderCommandType
  ) {}
}

export enum ProdOrderCommandType {
  PREPARE_ITEMS = 'PREPARE_ITEMS',

  EMIT_ITEMS = 'EMIT_ITEMS',

  EVALUATE_WORK_ORDER_COMPLETION_STATE = 'EVALUATE_WORK_ORDER_COMPLETION_STATE',

  EVALUATE_COMPLETION_STATE = 'EVALUATE_COMPLETION_STATE',

  EMIT_STORAGE_GROUP_UPSERT = 'EMIT_STORAGE_GROUP_UPSERT',
}

export class ProdOrderCommandResult {
  constructor(
    public order: ProdOrder,
    public type: ProdOrderCommandType,
    public success: boolean
  ) {}
}
